import { SvgIcon } from '@mui/material';
import SidebarMenuItem from 'components/SidebarMenu/SidebarMenuItem';
import SidebarMenuSection from 'components/SidebarMenu/SidebarMenuSection';
import { ROUTES } from 'constants/routes';
import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useNav } from 'utils/navigation';

interface IAuditMenuSectionProps {
	open: boolean;
	toggleOpen: () => void;
}

const AuditMenuSection: React.FC<IAuditMenuSectionProps> = ({
	open,
	toggleOpen
}) => {
	const nav = useNav();
	const location = useLocation();
	const active = Boolean(matchPath(ROUTES.audit, location.pathname));

	return (
		<SidebarMenuSection
			title={intl.tr('general.auditLog')}
			open={open}
			onTitleItemClick={toggleOpen}
			startIcon={<SvgIcon fontSize="small" />}
			testIdTopic="audit"
		>
			<SidebarMenuItem
				data-testid="audit-menu-item"
				active={active}
				buttonBaseProps={{
					onClick: () => nav(ROUTES.audit),
					'aria-current': active ? 'page' : undefined
				}}
				startIcon={<SvgIcon fontSize="small" />}
			>
				{intl.tr('audit.sidebar.item')}
			</SidebarMenuItem>
		</SidebarMenuSection>
	);
};

export default AuditMenuSection;
